var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomIcon',_vm._b({attrs:{"name":_vm.iconName}},'CustomIcon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }